import { env } from '@/env';
import type { LiveNowClass } from '@/models/interface/newCourse';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = env.apiBaseUrlNoVersion;

/**
 * 課程 v2 API
 * @remarks 走 `/api/v2` 路徑，與走 `/api/v1` 的 {@link NewCourseService} 分開
 */
export class NewCourseV2Service extends ApiFactory {
  constructor() {
    super(baseUrl);
  }

  /**
   * 取得當前正在直播中的直播室課程列表 (含加入連結)
   * @remarks 關閉全域 loading，讓列表自行處理載入狀態 (含背景輪詢刷新)
   */
  getLiveNowClasses(): Promise<ApiDataResponse<LiveNowClass[]>> {
    return super.get('v2/NewCourse/LiveNow', undefined, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }
}
